<template>
  <v-app-bar
    color="primary"
    height="6"
    class="border-z-index"
    :class="notification.show ? 'notification-position' : 'default-position'"
    fixed
    flat
  ></v-app-bar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Border",
  computed: {
    ...mapState({
      notification: state => state.notification
    })
  }
};
</script>

<style scoped>
.border-z-index {
  z-index: 6;
}

.notification-position {
  top: 72px;
}

.default-position {
  top: 0;
}
</style>
